// @flow
import { useEffect, useState } from 'react';
import getTrackCoachOnboarding from '../../api/getTrackCoachOnboarding';
import trackCoachOnboardingEvent from '../../api/trackCoachOnboardingEvent';

export default function useTrackCoachOnboarding() {
    const [trackCoachOnboarding, setTrackCoachOnboarding] = useState({});
    const [mobileSignInCollapsed, setMobileSignInCollapsed] = useState(false);
    const [createSessionCollapsed, setCreateSessionCollapsed] = useState(false);
    const [logSessionCollapsed, setLogSessionCollapsed] = useState(false);
    useEffect(() => {
        const init = async () => {
            const coachOnboarding = await getTrackCoachOnboarding();
            setTrackCoachOnboarding(coachOnboarding);
            setMobileSignInCollapsed(!!coachOnboarding.mobile_app_login_at);
            setCreateSessionCollapsed(!!coachOnboarding.self_session_create_at);
            setLogSessionCollapsed(!!coachOnboarding.self_session_log_at);
        };

        init();
    }, []);

    const trackVideoPlay = () => {
        trackCoachOnboardingEvent('video_view_at');
    };

    return {
        trackCoachOnboarding,
        mobileSignInCollapsed,
        setMobileSignInCollapsed,
        createSessionCollapsed,
        setCreateSessionCollapsed,
        logSessionCollapsed,
        setLogSessionCollapsed,
        trackVideoPlay
    };
}



// WEBPACK FOOTER //
// ./src/v5/home/components/hooks/useTrackCoachOnboarding.js